import { ivrService } from "@/common/api.service"
import { ivrStatus } from "@/constants/ivrStatus"

const initialStates = {
    status: 'loading',
    ivrs: [],
    form_data: {}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, ivrs) {
        state.status  = 'success'
        state.ivrs = ivrs
    },
    fail(state) {
        state.status  = 'fail'
        state.ivrs = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            if(key == 'sheba') {
                state.form_data[key] = []
            }else {
                state.form_data[key] = ''
            }
        });
    }
}

const getters = {
    status: ({status}) => status,
    ivrs: ({ivrs}) => ivrs,
    form_data: ({form_data}) => form_data,
    active_ivrs: ({ivrs}) => {
        if(ivrs.data) {
            return ivrs.data.filter(ivr =>
                ivr.status === ivrStatus.ACTIVE
            )
        }

        return ivrs.filter(ivr =>
            ivr.status === ivrStatus.ACTIVE
        )
    }
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return ivrService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return ivrService.fetch(params).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchUserGateways({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return ivrService.fetch(params).then(response => {
            commit('success', response.data.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        
        return ivrService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}